import { useQuery } from '@tanstack/react-query';
import { devlogService } from '@/services';

export function useDevLogs(page: number = 1) {
  return useQuery({
    queryKey: ['devlogs', page],
    queryFn: () => devlogService.getDevLogs(page),
    placeholderData: (previousData) => previousData,
  });
}
